// extracted by mini-css-extract-plugin
export default {"tooltip":"jW-z","arrow":"kW-z"};